import { render, staticRenderFns } from "./jikaoSj.vue?vue&type=template&id=829c8008&scoped=true"
import script from "./jikaoSj.vue?vue&type=script&lang=js"
export * from "./jikaoSj.vue?vue&type=script&lang=js"
import style0 from "./jikaoSj.vue?vue&type=style&index=0&id=829c8008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829c8008",
  null
  
)

export default component.exports